import { CommonModule } from '@angular/common';
import { Component, HostListener, NgModule, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { TemporaryRedelegationService } from '../../../services/temporaryredelegation/temporary-redelegation.service';
import { UserTempDOA } from '../../../interface/temporaryredelegation/user-temp-doa';
//import { Userdetails } from '../../../interface/temporaryredelegation/userdetails';
import { ActivatedRoute, Data, Router, RouterOutlet } from '@angular/router';
import { Redelegation } from '../../../interface/temporaryredelegation/redelegation';
import { EditorcancelredelegationComponent } from '../../../modules/temporaryredelegation/editorcancelredelegation/editorcancelredelegation.component';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedServices } from '../../../shared/services/shared.services';
import { RoleService } from '../../../shared/services/RoleService';
import { debounceTime, distinctUntilChanged } from 'rxjs';


@Component({
  selector: 'app-editredelegation',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterOutlet,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './editredelegation.component.html',
  styleUrl: './editredelegation.component.css'
})
export class EditredelegationComponent implements AfterViewInit {
  hasRoleA: boolean = false; 
  delegations: Redelegation[] = [];
  dataSource = new MatTableDataSource<Redelegation>([]);
  isLoading: boolean = false;
  loggedUserEmail: string = '';
  showTable: boolean = false;
  recordsPerPage: number = 10;
  showFields: boolean = false;
  showPaginator: boolean = false;
  displayedColumns: string[] = ['sno', 'fromName', 'toName', 'dueTo', 'startDate', 'endDate'];
  data: any[] = [];
  showContent: boolean = false;
  form!: FormGroup;
  today: string;
  tempDOA: UserTempDOA[] = [];
  selectedFields: string[] = [];
  UserEmail: any;
  eDate: Date = new Date();
  showNoDataMessage: boolean = false;
  showRedirectionComponent: boolean = false;
  public paginator!: MatPaginator;
  inputValues: { [key: string]: string } = {};
  modalCloseEvent: EventEmitter<void> = new EventEmitter<void>();
  
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(private fb: FormBuilder, private sharedService: SharedServices, private tempdelegationService: TemporaryRedelegationService, private route: ActivatedRoute, private router: Router, private roleService: RoleService) {
    this.form = this.fb.group({});
    this.today = new Date().toString().split('T')[0]; 
    this.modalCloseEvent.subscribe(() => {
      this.router.navigate(['/DOA']);
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.loggedUserEmail = this.sharedService.getloggedUserEmail();
    if (this.loggedUserEmail) {
      this.UserEmail = this.loggedUserEmail;
      this.loadData(this.loggedUserEmail);
    }
    this.form = this.fb.group({
      UserEmail: [''],
    });
    this.form.get('UserEmail')?.valueChanges.pipe(
      debounceTime(300), 
      distinctUntilChanged()
    ).subscribe(value => {
      if (!value) {
        this.clearData();
      }
    });

    this.sharedService.hasRoleA(this.roleService).subscribe(hasRole => {
      this.hasRoleA = hasRole;
    });
  }

  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }

  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const cursorPosition = inputElement.selectionStart;
    const fieldName = inputElement.id;
    this.inputValues[fieldName] = inputElement.value;
    setTimeout(() => {
      inputElement.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  }

  loadData(email: string) {
    this.isLoading = true;
    if (email) {
      this.tempdelegationService.showReDelegations(email).subscribe(
        (data: Redelegation[]) => {
          if (data && data.length > 0) {
            this.showContent = true;
            this.showNoDataMessage = false;
            this.delegations = data;
            this.dataSource.data = data;
            this.setDataSourceAttributes();
            this.showPaginator = true;
            this.showTable = true;
          } else {
            this.showNoDataMessage = true;
            this.showTable = false;
          }
          this.isLoading = false;
        },
        error => {
          this.showNoDataMessage = true;
          this.showTable = false;
          this.isLoading = false;
        }
      );
    } else {
      this.clearData();
    }
  }

  clearData() {
    this.showContent = false;
    // Do not reset the form here to avoid clearing the email input
    // Reset other states as needed
    this.showNoDataMessage = false;
    this.delegations = [];
    this.dataSource.data = [];
    this.showPaginator = false;
    this.showTable = false;
  }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }

  getReq(userEmail: string, eDate: Date): void {
    this.router.navigate(['/TemporaryRedelegation/EditCancelRedelegation'], { queryParams: { userEmail, eDate: eDate.toString() }, relativeTo: this.route });
  }

  cancel(): void {
    this.modalCloseEvent.emit();
  }

  // Method to handle search button click
  onSearch() {
    const email = this.form.get('UserEmail')?.value;
    if (email) {
      this.loadData(email);
    }
  }
}
